import { queryOptions, useQuery } from "@tanstack/react-query";
import { fetchProfile } from "../clients/profileClient";

export const profileQueryOptions = () =>
  queryOptions({
    queryKey: ["self-profile"],
    queryFn: fetchProfile,
    staleTime: 30_000,
  });

export function useProfileQuery() {
  return useQuery(profileQueryOptions());
}
